module.exports = __webpack_public_path__ + "static/media/Hibisco_750.9f1ed8dd.jpg";